<script setup lang="ts">
/**
 * Renderuje nadpis a inštrukcie pre sekciu formulára ŽoPPM.
 */
import { richTextToGovukHtml } from '/@src/utils/richTextToGovukHtml'
import { computed } from 'vue'

interface ZoppmTitleInstructions {
  nadpis: string
  instrukcie?: string
  level?: number
}

const props = withDefaults(defineProps<ZoppmTitleInstructions>(), {
  instrukcie: undefined,
  level: 0,
})

const heading = computed(() => {
  switch (props.level) {
    case 1:
      return 'h2'
    case 2:
      return 'h3'
    default:
      return 'h1'
  }
})

const variant = computed(() => {
  switch (props.level) {
    case 1:
      return 'l'
    case 2:
      return 'm'
    default:
      return 'xl'
  }
})

const headingClass = computed(() => {
  switch (props.level) {
    case 1:
      return 'mb-6'
    case 2:
      return 'mb-6'
    default:
      return 'mb-7'
  }
})

const instructionsClass = computed(() => {
  switch (props.level) {
    case 1:
      return 'mb-4'
    case 2:
      return 'mb-4'
    default:
      return 'mb-6'
  }
})
</script>

<template>
  <div v-if="props.nadpis || props.instrukcie" data-section="title-instructions">
    <IDSKHeading :class="headingClass" :as="heading" :variant="variant">
      {{ props.nadpis }}
    </IDSKHeading>
    <div
      v-if="props.instrukcie"
      :class="instructionsClass"
      v-html="richTextToGovukHtml(props.instrukcie, 'mb-0')"
    />
  </div>
</template>

<style scoped></style>
